import React from "react";
import { useDispatch } from "react-redux";
import { setModalState, modalViewsConst } from "../../store/modalSlice";
import ModalBase from "./ModalBase";

interface ConfirmAddAssetFromMapModalProps {
  lat?: number;
  lng?: number;
  assetGroupId?: string;
  onClose?: (result?: any) => void;
}

const ConfirmAddAssetFromMapModal: React.FC<ConfirmAddAssetFromMapModalProps> = ({
  lat,
  lng,
  assetGroupId,
  onClose,
}) => {
  const dispatch = useDispatch();

  const handleCancel = () => {
    onClose?.();
  };

  const handleConfirm = () => {
    dispatch(
      setModalState({
        modalOpen: true,
        modalView: modalViewsConst.addAssetNEW,
        properties: {
          __modalSize: "md",
          assetGroupId,
          lat,
          lng,
        },
      })
    );
  };

  return (
    <ModalBase
      title="Create an asset here?"
      onClose={handleCancel}
      size="xs"
      footer={
        <>
          <button className="flex-1 eai-btn" onClick={handleCancel}>
            Cancel
          </button>
          <button className="flex-1 eai-btn-grn" onClick={handleConfirm}>
            Create Asset
          </button>
        </>
      }
    >
      <div className="flex flex-col gap-2">
        <div className="flex justify-between text-sm text-gray-700">
          <span className="font-medium">Latitude</span>
          <span className="font-mono">{lat?.toFixed(6)}</span>
        </div>
        <div className="flex justify-between text-sm text-gray-700">
          <span className="font-medium">Longitude</span>
          <span className="font-mono">{lng?.toFixed(6)}</span>
        </div>
      </div>
    </ModalBase>
  );
};

export default ConfirmAddAssetFromMapModal;
